import React, {useState, useMemo} from "react";
import PropTypes from "prop-types";
import {formatPrice} from "../../../../utils/format";
import {Trans, useTranslation} from "react-i18next";
import {ResultBox, Nights, Price, AvailableBerths, Text, Deposit} from "./styles";
import InstantBookingInfoDialog from "../InstantBookingInfoDialog/InstantBookingInfoDialog";
import {PriceAndPromotionsWrapper} from "../ReservationInputs/ReservationInputs.style";
import PromotionEstimations from "../../../SinglePage/Reservation/PromotionEstimations";
import BeforeApprovalForm from   "../../../SinglePage/Reservation/beforeApprovalForm";

const AvailableBerthsBox = props => {
    const {
        mode,
        marina,
        proposal,
        isLoggedIn,
        tooLate,
        sizeLimit,
        diff,
        daysInAdvance,
        offline,
        calculatedPrice,
        passeportEscales,
        isInstantBookingDisabled,
        isNewVessel,
        requirements_before_approval,
        formik,
        bookingRequestSubmitted
    } = props;
    const {t} = useTranslation();
    const [moreInfo, setMoreInfo] = useState(false);
    const marinaLogos = useMemo(() => {
        return marina &&
            ((process.env.REACT_APP_FIREBASE_ENV === 'TEST' && marina.id === 411) ||
                (process.env.REACT_APP_FIREBASE_ENV === 'PRODUCTION' && marina.id === 82)
            );
    }, [marina]);

    const marinaPuertoSherry = useMemo(() => {
        return marina &&
            ((process.env.REACT_APP_FIREBASE_ENV === 'TEST' && marina.id === 352) ||
                (process.env.REACT_APP_FIREBASE_ENV === 'PRODUCTION' && marina.id === 98)
                ||  (process.env.REACT_APP_FIREBASE_ENV === 'DEVELOPMENT' && marina?.id ===5));
    }, [marina]);

    const tooLate_title = daysInAdvance === 1? t('TOO_LATE_TITLE_SINGLE') : t('TOO_LATE_TITLE', {days: daysInAdvance});
    const notCovered = proposal?.price?.count_descriptions === 'RESERVATION_IS_NOT_COVERED_IN_THE_MARINA_SEASONS';
    if (mode !== 'SEND_A_BOOKING_REQUEST' && ((!proposal && !tooLate && !isInstantBookingDisabled && !(passeportEscales && calculatedPrice)) || (isInstantBookingDisabled  && !calculatedPrice))) return null;

    return <>
        {!tooLate && !offline && proposal && (proposal.available_berths === null || proposal.available_berths > 0) && proposal.price ?
            <ResultBox success>
                <AvailableBerths>
                    {proposal.available_berths === null ?
                        t('AVAILABLE_INSTANT_BOOKING_BERTHS_GENERAL')
                        :
                        t(proposal.available_berths === 1 ? 'AVAILABLE_INSTANT_BOOKING_BERTH'
                            : 'AVAILABLE_INSTANT_BOOKING_BERTHS', {berth_count: proposal.available_berths})
                    }
                </AvailableBerths>
                <Price>
                    {formatPrice(proposal.price?.total_to_pay?.toString(), 'en', marina?.marina_settings?.currency)}
                </Price>
                <Nights>
                    {t(proposal.price?.reservation_duration === 1 ? (marinaLogos || marinaPuertoSherry) ? 'FOR_NIGHT_INCLUDING_VAT' : 'FOR_NIGHT' : (marinaLogos || marinaPuertoSherry) ? 'FOR_NIGHTS_INCLUDING_VAT' : 'FOR_NIGHTS',
                        {nights: proposal.price?.reservation_duration})}
                </Nights>
                {(calculatedPrice?.deposit && calculatedPrice.deposit !== calculatedPrice.total_to_pay) ? <Deposit>
                    {t('PAY_NOW_ONLY_DEPOSIT', {amount: formatPrice(calculatedPrice.deposit?.toString(), 'en', marina?.marina_settings?.currency)})}
                </Deposit> : ''}
                <PriceAndPromotionsWrapper>
                        <PromotionEstimations
                            centerAndFill
                            pricing={calculatedPrice}
                            marina_settings={marina?.marina_settings || {}}
                        />
                    </PriceAndPromotionsWrapper>
            </ResultBox> :
            ((isInstantBookingDisabled || passeportEscales) && calculatedPrice) ?
            <>
                <ResultBox success>
                        <AvailableBerths bold>
                            {formatPrice(calculatedPrice.total_to_pay?.toString(), 'en', marina?.marina_settings?.currency) + " | " + t("TOTAL_PRICE")}
                        </AvailableBerths>
                        <Text center>
                            {t('RESERVATION_PRICE_DISCLAIMER')}
                        </Text>
                        <PriceAndPromotionsWrapper>
                        <PromotionEstimations
                            centerAndFill
                            pricing={calculatedPrice}
                            marina_settings={marina?.marina_settings || {}}
                        />
                    </PriceAndPromotionsWrapper>
                </ResultBox>

                <ResultBox success={false}>
                    <Text>
                        <Trans
                            i18nKey={ 'INSTANT_BOOKING_DISABLED' }>
                            a<span onClick={() => setMoreInfo(true)}>b</span>
                        </Trans>
                    </Text>
                    <BeforeApprovalForm
                        formik ={formik}
                        requirements_before_approval={requirements_before_approval}
                        isLoggedIn={isLoggedIn}
                        isNewVessel={isNewVessel}
                        submitted={bookingRequestSubmitted}

                    />
                </ResultBox>
            </>
                :
            <div>
                {proposal && proposal.price?.total_to_pay !== undefined ?
                    <ResultBox success>
                        <AvailableBerths bold>
                            {!sizeLimit && !tooLate && !proposal.cannot_be_booked_instantly &&
                                formatPrice(proposal.price.total_to_pay?.toString(), 'en', marina?.marina_settings?.currency) + " | " + t("TOTAL_PRICE")}
                            {(sizeLimit || tooLate || proposal.cannot_be_booked_instantly) && calculatedPrice &&
                                formatPrice(calculatedPrice.total_to_pay?.toString(), 'en', marina?.marina_settings?.currency) + " | " + t("TOTAL_PRICE")}
                        </AvailableBerths>
                        <Text center>
                            {t('RESERVATION_PRICE_DISCLAIMER')}
                        </Text>
                        <PriceAndPromotionsWrapper>
                        <PromotionEstimations
                            centerAndFill
                            pricing={calculatedPrice}
                            marina_settings={marina?.marina_settings || {}}
                        />
                    </PriceAndPromotionsWrapper>
                    </ResultBox>
                    : null}
                <ResultBox success={false}>
                    <Text bold>{tooLate ? tooLate_title: (sizeLimit || notCovered) ? t('CANNOT_BOOK_INSTANTLY_TITLE_SIZE_RESTRICTION') : t('NO_AVAILABLE_BERTHS_LEFT') }</Text>
                    <Text>
                        <Trans
                            i18nKey={ (sizeLimit || notCovered) ? 'CANNOT_BOOK_INSTANTLY_TEXT' : 'TOO_LATE_SUBTITLE'}>
                            a<span onClick={() => setMoreInfo(true)}>b</span>
                        </Trans>
                    </Text>
                    <BeforeApprovalForm
                        formik ={formik}
                        requirements_before_approval={requirements_before_approval}
                        isLoggedIn={isLoggedIn}
                        isNewVessel={isNewVessel}
                        submitted={bookingRequestSubmitted}
                    />

                </ResultBox>
            </div>
        }
        <InstantBookingInfoDialog
            open={moreInfo}
            onClose={() => setMoreInfo(false)}
            variant={tooLate ? "toolate" : (sizeLimit ? 'size' : "unavailable")}
            diff={diff}
            restriction={daysInAdvance ? Number(daysInAdvance) : undefined}
            marina={marina}
        />
    </>;
}

AvailableBerthsBox.propTypes = {
    mode: PropTypes.oneOf(['CHECK_AVAILABILITY', 'ESTIMATE_PRICE', 'CONTINUE_TO_BOOKING', 'SEND_A_BOOKING_REQUEST' , 'NONE']),
    marina: PropTypes.object,
    proposal: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    tooLate: PropTypes.bool,
    sizeLimit: PropTypes.bool,
    diff: PropTypes.number,
    daysInAdvance: PropTypes.string,
    offline: PropTypes.bool,
    calculatedPrice:PropTypes.object,
    passeportEscales:PropTypes.bool,
    isNewVessel: PropTypes.bool,
    requirements_before_approval: PropTypes.object,
    formik: PropTypes.object,
    bookingRequestSubmitted: PropTypes.bool
}

export default AvailableBerthsBox;
